<div class="h-full w-full flex flex-col justify-start items-start">
  <div class="flex flex-row justify-start items-center gap-2">
    @if (!fromProjectAccordion) {
      <div class="text-xl font-medium">
        {{ isProject ? 'Projektmitglieder' : 'Organisationsmitglieder' }}
      </div>
    }
    @if (!fromProjectAccordion) {
        <button (click)="addUser()" [disabled]="addDisabled" mat-raised-button>
        <fa-icon [icon]="faUserPlus" class="text-white text-xl"></fa-icon>
      </button>
    }
  </div>

  <div class="w-full h-full bg-white" [ngClass]="{'shadow-full rounded-md': !fromProjectAccordion}">
    <div class="w-full h-full flex flex-col flex-nowrap content-between gap-5">

      <cdk-table #usersTbSort="matSort" [dataSource]="dataSource"
                 class="w-full h-full text-sm text-left text-gray-500 border border-gray-200 rounded-lg overflow-hidden"
                 matSort
                 matSortActive="lastName"
                 matSortDirection="asc">

        <!-- firstname column -->
        <ng-container cdkColumnDef="firstName">
          <cdk-header-cell *cdkHeaderCellDef class="shrink-0 w-[15%] h-full pl-7 py-4 text-gray-500 text-xs font-semibold"> Vorname</cdk-header-cell>
          <cdk-cell *cdkCellDef="let element" class="shrink-0 w-[15%] pl-7 py-1 truncate"> {{ element.firstName }}
          </cdk-cell>
        </ng-container>

        <!-- surname column -->
        <ng-container cdkColumnDef="lastName">
          <cdk-header-cell *cdkHeaderCellDef class="shrink-0 w-[20%] h-full py-4 text-gray-500 text-xs font-semibold">Nachname</cdk-header-cell>
          <cdk-cell *cdkCellDef="let element" class="shrink-0 w-[20%] py-1 truncate">{{ element.lastName }}</cdk-cell>
        </ng-container>

        <!-- email column -->
        <ng-container cdkColumnDef="mail">
          <cdk-header-cell *cdkHeaderCellDef class="shrink-0 w-[29%] h-full pr-4 py-4 text-gray-500 text-xs font-semibold">E-Mail</cdk-header-cell>
          <cdk-cell *cdkCellDef="let element" class="shrink-0 w-[29%] py-1 truncate">{{ element.mail }}</cdk-cell>
        </ng-container>


        <!-- authorization column -->
        <ng-container matColumnDef="authorization">
          <cdk-header-cell *cdkHeaderCellDef class="shrink-0 w-[20%] h-full pl-8 pr-4 text-gray-500 text-xs font-semibold">Berechtigung</cdk-header-cell>
          <cdk-cell *cdkCellDef="let element" class="shrink-0 w-[20%] py-1 break-words cursor-default pl-2">
            <div [bicDropdownTrigger]="authDropdown" (click)="permissionToAddUser(element); $event.stopPropagation()"
              (document:click)="onClickSomewhereToCloseMenues()"
              [class]=" (permissionsDisabled || element.id == user.id) ? 'cursor-not-allowed' : 'cursor-pointer' "
                 class="flex flex-row justify-start items-center gap-2">

              <div class="flex flex-row" [class]="(permissionsDisabled || element.id == user.id) ? 'cursor-not-allowed' : 'cursor-pointer' ">
                  <fa-icon [class.text-gray-200]="permissionsDisabled || element.id == user.id"
                           [class]=" (permissionsDisabled || element.id == user.id) ? 'cursor-not-allowed text-gray-400' : 'cursor-pointer' "
                         [icon]="faChevronDown"
                         class="text-gray-900 text-sm"></fa-icon>
              </div>

              <div
                      [class]=" (permissionsDisabled || element.id == user.id) ? 'cursor-not-allowed text-gray-400' : 'cursor-pointer' "
                class="flex flex-row break-all">
                <div
                  class="overflow-hidden w-full line-clamp-1"
                  [tooltip]="getCurrentRoleTooltip(element)">
                  {{ $safeNavigationMigration(getCurrentRole(element)?.name) | roleAndPrivileges }}
                </div>
              </div>

              <!-- old cdkConnectedOverlay login dropdown removed -->
            </div>
            <bic-dropdown #authDropdown (close)="closeCustomRoleOverlay()" [dropdownPlacement]="'bottom-start'">
            @if (this.authToDropdownFrom != undefined) {

            <!-- default roles -->

              <bic-dropdown-element class="justify-between" (click)="$event.stopPropagation(); updateUser(element, roles[0])" >
                   <span class="text-gray-900 w-[140px]"> {{ roles[0].name | roleAndPrivileges }} </span>
                <div class="justify-start">
                  <fa-icon (click)="clickedInDropdown = true; openedSubMenu()"
                           [icon]="faCircleInfo"
                           [tooltip]="getRoleTooltip(roles[0])" class="text-gray-300 cursor-pointer"
                           iconRight></fa-icon>
                </div>
              </bic-dropdown-element>

              <bic-dropdown-element class="justify-between" (click)="$event.stopPropagation(); updateUser(element, roles[1])">
                <span class="text-gray-900 w-[140px]"> {{ roles[1].name | roleAndPrivileges }} </span>
                <div class="justify-start">
                <fa-icon (click)="clickedInDropdown = true; openedSubMenu()"
                         [icon]="faCircleInfo"
                         [tooltip]="getRoleTooltip(roles[1])" class="text-gray-300 cursor-pointer" iconRight></fa-icon>
              </div>
              </bic-dropdown-element>

              <bic-dropdown-element class="justify-between" (click)="$event.stopPropagation(); updateUser(element, roles[2])">
                <span class="text-gray-900 w-[140px]"> {{ roles[2].name | roleAndPrivileges }} </span>
                <div class="justify-start">
                <fa-icon (click)="clickedInDropdown = true; openedSubMenu()"
                         [icon]="faCircleInfo"
                         [tooltip]="getRoleTooltip(roles[2])" class="text-gray-300 cursor-pointer" iconRight></fa-icon>
              </div>
              </bic-dropdown-element>


                  @for (role of customRoles; track role) {
                        <bic-dropdown-element >
                          <span class="text-gray-900 w-[140px] truncate" (click)="$event.stopPropagation(); updateUser(element, role)">
                            {{ role.name }}
                          </span>
                          <div iconRight #customAuthEditTrigger="cdkOverlayOrigin" cdkOverlayOrigin
                               (click)="selectedCustomRole = role; editCustomRole(selectedCustomRole)"
                               class="flex flex-row items-center justify-center w-4 hover:cursor-pointer">
                            <fa-icon [icon]="faPenToSquare" class="text-gray-900"></fa-icon>
                          </div>
                          </bic-dropdown-element>
                  }

                  <!-- authorization custom roles edit menu -->
<!--                  <ng-template-->
<!--                    cdkConnectedOverlay-->
<!--                    [cdkConnectedOverlayOrigin]="triggerOrigin!"-->
<!--                    [cdkConnectedOverlayOpen]="isCustomRoleOverlayOpen"-->
<!--                    [cdkConnectedOverlayHasBackdrop]="true"-->
<!--                    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"-->
<!--                    (backdropClick)="closeCustomRoleOverlay()"-->
<!--                    (detach)="closeCustomRoleOverlay()">-->
<!--                    <div class="flex flex-col w-[196px] justify-between border border-gray-200 rounded-md bg-white">-->
<!--                      <div class="hover:bg-gray-100 hover:cursor-pointer">-->
<!--                        <div (click)="selectedCustomRole && editCustomRole(selectedCustomRole); closeCustomRoleOverlay()"-->
<!--                             class="flex flex-row justify-between items-center w-full py-2 px-4 text-gray-900 text-sm font-normal">-->
<!--                          <div>Bearbeiten</div>-->
<!--                          <fa-icon [icon]="faPenToSquare"></fa-icon>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div (click)="selectedCustomRole && deleteCustomRole(selectedCustomRole); closeCustomRoleOverlay()"-->
<!--                           [ngClass]="{'hover:bg-gray-100 hover:cursor-pointer': !isRoleAssigned(selectedCustomRole),'text-gray-300 cursor-not-allowed': isRoleAssigned(selectedCustomRole)}">-->
<!--                        <div class="flex flex-row justify-between items-center w-full py-2 px-4 text-sm font-normal">-->
<!--                          <div [ngClass]="{'text-red': !isRoleAssigned(selectedCustomRole),'text-gray-300': isRoleAssigned(selectedCustomRole)}">Löschen</div>-->
<!--                          <fa-icon [icon]="faTrash" [ngClass]="{'text-red': !isRoleAssigned(selectedCustomRole),'text-gray-300': isRoleAssigned(selectedCustomRole)}"></fa-icon>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </ng-template>-->

                  <!-- button to create a new custom role -->
                  <bic-dropdown-element (click)="$event.stopPropagation(); createCustomRole(element)">
                      Benutzerdefiniert
                      <fa-icon iconRight [icon]="faPlus" class="text-gray-900"></fa-icon>
                  </bic-dropdown-element>

            }
            </bic-dropdown>

          </cdk-cell>
        </ng-container>

        <!-- organisationList column -->
        <ng-container cdkColumnDef="organisation">
          <cdk-header-cell *cdkHeaderCellDef class="shrink-0 w-[18%] h-full pl-6 py-4 font-medium">Organisation
          </cdk-header-cell>
          <cdk-cell *cdkCellDef="let element" class="shrink-0 w-[18%] pl-6 py-1 break-words">Building Information-Dummy
          </cdk-cell>
        </ng-container>

        <!-- actions column -->
        <ng-container cdkColumnDef="actions">
          <cdk-header-cell *cdkHeaderCellDef class="flex flex-row grow h-full justify-end py-4 font-medium pr-4">

          </cdk-header-cell>
          <cdk-cell *cdkCellDef="let element" class="flex flex-row grow justify-end items-center py-1 pr-4 gap-4">
            @if (isCreator(element)) {
              <bic-badge type="info">Ersteller*in</bic-badge>
            }
            <button
                    type="button"
                    class="inline-flex h-7 w-7 shrink-0 items-center justify-center"
                    [class.cursor-pointer]="canRemoveUser(element)"
                    [class.cursor-not-allowed]="!canRemoveUser(element)"
                    [tooltip]="permissionsDisabled ? 'Nicht möglich': isProject ? 'Projektmitglied entfernen' : 'Organisationsmitglieder entfernen'" [tooltipDirection]="'left'" (click)="removeUser(element);"
                    [disabled]="!canRemoveUser(element)">
              <div class="flex flex-row w-full">
                <fa-icon  [icon]="faTrash"
                          [class.text-gray-200]="!canRemoveUser(element)"
                          [class.text-red]="canRemoveUser(element)"
                          class="text-base text-red"
                ></fa-icon>
              </div>
            </button>

          </cdk-cell>
        </ng-container>

        <!-- table definition -->
        @if (isProject) {
          <cdk-header-row *cdkHeaderRowDef="displayedColumnsProject"
                          class="flex flex-row justify-between items-center w-full border-b-1 border-gray-200  font-semibold text-gray-400 bg-gray-50 uppercase select-none"></cdk-header-row>
          <cdk-row *cdkRowDef="let row; columns: displayedColumnsProject;"
                   class="group flex flex-row justify-between py-2 items-center text-gray w-full last:border-none hover:bg-gray-100 bg-white border-gray-200 border-b"></cdk-row>
        }
        @if (!isProject) {
          <cdk-header-row *cdkHeaderRowDef="displayedColumnsOrganisation"
                          class="flex flex-row justify-between items-center w-full border-b-1 border-gray-200 font-semibold text-gray-400 bg-gray-50 uppercase select-none"></cdk-header-row>
          <cdk-row *cdkRowDef="let row; columns: displayedColumnsOrganisation;"
                   class="group flex flex-row justify-between py-2 items-center text-gray w-full last:border-none hover:bg-gray-100 bg-white border-gray-200 border-b"></cdk-row>
        }
      </cdk-table>

      @if (fromProjectAccordion) {
        <div class="flex flex-row justify-end">
          <bic-button
            (click)="addUser()"
            [disabled]="addDisabled || !canAddUser"
            [tooltip]="addDisabled ? 'Keine Berechtigung' : isProject ? 'Projektmitglied hinzufügen' : 'Organisationsmitglied hinzufügen'" buttonType="white">
            <fa-icon [icon]="faUserPlus" iconLeft></fa-icon>
            Hinzufügen
          </bic-button>
        </div>
      }
    </div>
  </div>

</div>
